export const TRANSACTION_LIST_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  search: {
    type: 'text',
    key: 'search',
    label: 'Search',
    placeholder: 'Search (Trans Ref)',
  },
  status: {
    type: 'select',
    key: 'current_status',
    label: 'Status',
  },
  from_date: {
    type: 'text',
    key: 'from_date',
    placeholder: 'Start date',
  },
  to_date: {
    type: 'text',
    key: 'to_date',
    placeholder: 'End Date',
  },
} as const;

export const TRANSACTION_STATUS = [
  { name: 'Paid', value: 'Paid' },
  { name: 'Reject', value: 'Reject' },
  { name: 'Partial Payment', value: 'Partial Payment' },
  { name: 'Cancelled', value: 'Cancelled' },
  { name: 'Submitted', value: 'Submitted' },
];
